import {
  FETCH_ALL,
  ADD_NEW,
  UPDATE,
  DELETE,
  GET_INVOICE,
  CLEAR_INVOICE,
  START_LOADING,
  SOFTDELETE,
  FETCH_DELETED_INVOICES,
  END_LOADING,
  FETCH_INVOICE_BY_USER,
  FETCH_INVOICE_BY_CLIENT,
} from "../actions/constants";

const invoices = (
  state = { isLoading: true, invoices: [], deletedInvoices: [] },
  action
) => {
  switch (action.type) {
    case START_LOADING:
      return { ...state, isLoading: true };
    case END_LOADING:
      return { ...state, isLoading: false };
    case FETCH_ALL:
      return {
        ...state,
        invoices: action.payload,
        currentPage: action.payload.currentPage,
        numberOfPages: action.payload.numberOfPages,
      };
    case FETCH_INVOICE_BY_USER:
      return { ...state, invoices: action.payload };
    case FETCH_INVOICE_BY_CLIENT:
      return {
        ...state,
        invoices: action.payload.invoices,
        numberOfPages: action.payload.totalItems,
        totalAmount: action.payload.totalAmount,
      };
    case GET_INVOICE:
      return { ...state, invoice: action.payload };
    case CLEAR_INVOICE:
      return { ...state, invoice: null };
    case ADD_NEW:
      // Prepended: getInvoices sorts newest-first ({_id:-1}) - appending put
      // a just-created invoice at the end of the in-memory list, off the
      // first page of a newest-first table.
      return { ...state, invoices: [action.payload, ...state.invoices] };
    case UPDATE:
      return {
        ...state,
        invoices: state.invoices.map((invoice) =>
          invoice._id === action.payload._id ? action.payload : invoice
        ),
        // Without this, a component reading state.invoices.invoice (the
        // single invoice GET_INVOICE populated - InvoiceDetails.js's whole
        // page) kept showing pre-update data after a save here, even though
        // the server had it right - the only workaround was a full page
        // reload (see Payments/Modal.js, before this fix).
        invoice:
          state.invoice?._id === action.payload._id ? action.payload : state.invoice,
      };
    case DELETE:
      return {
        ...state,
        invoices: state.invoices.filter(
          (invoice) => invoice._id !== action.payload
        ),
      };
    case SOFTDELETE:
      return {
        ...state,
        invoices: state.invoices.filter(
          (invoice) => invoice._id !== action.payload
        ),
      };
    case FETCH_DELETED_INVOICES: // Add this case
      return { ...state, deletedInvoices: action.payload };
    default:
      return state;
  }
};

export default invoices;

//   const invoices =( state = { invoices: [], }, action ) => {
//     switch (action.type) {
//         case FETCH_ALL:
//             return { ...state, invoices: action.payload }

//         case GET_INVOICE:
//             return { ...state, invoice: action.payload }

//         case ADD_NEW:
//             return { ...state, invoices: [...state.invoices, action.payload] }

//         case UPDATE:
//             return { ...state, invoices: state.invoices.map((invoice) => invoice._id === action.payload ? action.payload : invoice) }

//         case DELETE:
//         return {...state, invoices: state.invoices.filter((invoice) => invoice._id !== action.payload)}

//         default:
//             return state;
//     }
// }

// export default invoices
